<template>
	<div class="printer-category-setting-container">
		<ModalHeader :title="selectedMenuName" :button-text="getString('save')" @click-button="saveCategories" />
		<div class="alignment-row row-select-menu">
			<p>{{ getString('menu_select', [userStore.menuWord]) }}</p>
			<AppSelect
				class="right-element"
				:title="getString('select')"
				:values="selectableMenus"
				:selected-index="selectedMenuIndex"
				@selected="changeMenu"
			/>
		</div>
		<AppList :items="sortedCategoriesItems">
			<template v-slot:checklist-category="{ item }">
				<div class="alignment-row">
					<p>{{ getString(item.title) }}</p>
					<AppSelect
						class="right-element"
						:title="getString('select')"
						:values="printTypes"
						:selected-index="item.printTypeIndex"
						@selected="type => changePrintType(item.categoryId, type)"
					/>
				</div>
			</template>
		</AppList>
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useMenuStore, useKitchenMonitorsStore, useUserStore} from "@/console-new/stores";
import AppButton from "@/shared/components/AppButton.vue";
import AppList from "@/shared/components/AppList.vue";
import AppChecklist from "@/shared/components/AppChecklist.vue";
import AppSelect from "@/shared/components/AppSelect.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const menuStore = useMenuStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		const kitchenMonitorsStore = useKitchenMonitorsStore();
		return {
			getString: languageStore.getString,
			menuStore,
			userStore,
			showNotification: notificationStore.showNotification,
			kitchenMonitorsStore,
		}
	},
	name: "KitchenStationCategoriesEditor",
	emits: ["close"],
	components: {AppSelect, AppChecklist, AppList, AppButton, ModalHeader},
	data() {
		return {
			selectedMenu: null,
		}
	},
	props: {
		stationId: {
			type: Number,
			required: true,
		},
	},
	computed: {
		station() {
			let foundStation = this.stationId && this.kitchenMonitorsStore?.stationsMap ? this.kitchenMonitorsStore.stationsMap[this.stationId] : {};
			return foundStation || {};
		},
		selectedMenuIndex() {
			let index = 0;
			for(let i = 0; i < this.sortedMenus.length; i++) {
				if(this.sortedMenus[i].menu_id === this.menuStore.modMenu.menu_id) {
					index = i;
					break;
				}
			}
			return index;
		},
		selectedMenuName() {
			return this.menuStore.modMenu.name || this.userStore.menuWord;
		},
		selectableMenus() {
			return this.sortedMenus.map(r => r.name || this.userStore.menuWord);
		},
		sortedMenus() {
			return this.menuStore.sortedMenus;
		},
		sortedCategories() {
			let newCategoriesArray = Object.values(this.menuStore.modMenu.categories).sort((a, b) => a.order_number - b.order_number);
			newCategoriesArray = newCategoriesArray.filter(r => !r.variations_only && !r.additional_costs_shortcuts);
			return newCategoriesArray;
		},
		sortedCategoriesItems() {
			return this.sortedCategories.map(r => {
				let printTypeIndex = 0;
				if(this.categoriesExcludedMap[r.menu_category_id]) {
					printTypeIndex = 1;
				}
				if(this.categoriesSmallMap[r.menu_category_id]) {
					printTypeIndex = 2;
				}
				return {
					title: r.name || this.getString("no_name"),
					customSlot: "checklist-category",
					printTypeIndex: printTypeIndex,
					categoryId: Number(r.menu_category_id),
				}
			});
		},
		categoriesExcludedMap() {
			let excludedMap = {};
			for(let catId in this.station.exclude_categories) {
				if(!this.station.exclude_categories[catId].print_small) {
					excludedMap[catId] = catId;
				}
			}
			return excludedMap;
		},
		categoriesSmallMap() {
			let smallMap = {};
			for(let catId in this.station.exclude_categories) {
				if(this.station.exclude_categories[catId].print_small) {
					smallMap[catId] = catId;
				}
			}
			return smallMap;
		},
		printTypes() {
			return [
				this.getString("show"),
				this.getString("dont_show"),
				this.getString("show_small"),
			];
		},
	},
	methods: {
		changeMenu(i) {
			let menus = this.sortedMenus;
			if(i < menus.length) {
				let selectedMenu = menus[i];
				if(selectedMenu) {
					this.menuStore.changeModMenu(selectedMenu.menu_id);
				}
			}
		},
		changePrintType(categoryId, newType) {
			if(newType === 0) {
				delete this.station.exclude_categories[categoryId];
			} else {
				this.station.exclude_categories[categoryId] = {
					print_small: newType === 2,
					user_id: Number(this.station.user_id),
					menu_category_id: Number(categoryId),
				};
			}
		},
		saveCategories() {
			this.kitchenMonitorsStore.kitchenStationUpdateExcludedCategories(this.userStore.currBusinessId, this.station.user_id, this.station.exclude_categories, catSuccess => {
				this.showNotification(catSuccess ? 'generic-success' : 'generic-fail');
				if(catSuccess) {
					this.$emit("close");
				}
			});
		}
	},
	mounted() {
		let menuId = this.menuStore.getMenuIndex(localStorage.getItem("last_menu_id"));
		if(menuId) {
			this.changeMenu(menuId);
		}
	},
}
</script>

<style scoped lang="scss">
.printer-category-setting-container {
	.alignment-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		gap: 10px;

		.right-element {
			margin-left: auto;
		}
	}
	.row-select-menu {
		border-radius: 13px;
		padding: 8px 12px;
		margin-bottom: 20px;
		background-color: var(--color-alpha-1);
	}
}
</style>